module.exports = __webpack_public_path__ + "static/img/4.e4b6c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/4.png
// module id = cF73
// module chunks = 2